module.exports = __webpack_public_path__ + "c9d3e20e346d8b1610986e12d428ca3f.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/language-yellow.svg
// module id = 2887
// module chunks = 24